<script setup lang="ts">
import {FraudReport} from "@/core/interfaces/fraud/fraud";
import dateHelper from "@/core/helpers/dateHelper";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {Dialog, DialogContent, DialogTitle, DialogTrigger} from "@/core/components/ui/dialog";
import {computed} from "vue";
import {FileUrl} from "@/core/interfaces/FileUrl";
import SecureImage from "@/core/components/secure-image/SecureImage.vue";

const props = defineProps<{
  report: FraudReport;
}>();

/** The prescription media urls. */
const urls = computed((): FileUrl[] => {
    const route = `fraud-reports/${props.report.id}`;

    return [{
        'pdf': import.meta.env.VITE_HDS_URL + `/${route}/document`,
        'raw': `${route}/document`,
        'thumbnail': {
            'large': `${route}/image`,
            'small': `${route}/image`
        }
    }];
});
</script>

<template>
  <div class="bg-white w-full rounded-sm p-4 flex flex-col gap-4">
    <div class="flex w-full">
      <div class="flex flex-1 text-primary font-bold">
        Signalement n°{{ report.asafo_key }}
      </div>
      <div class="flex flex-1 justify-end">
        <em>Avéré le {{ dateHelper.dayOnlyLongFormat(report.status_date) }}</em>
      </div>
    </div>
    <div class="flex gap-2 v-full">
      <div class="flex flex-col flex-1">
        <h3>Document falsifié</h3>
        <div>
          Ordonnance du {{ dateHelper.dayOnlyLongFormat(report.prescription_date) }}
        </div>
        <div v-if="report.professional?.type === 'PS'">
          Prescrit par Dr {{ report.professional.first_name }} {{ report.professional.name }}
        </div>
        <div v-if="report.professional?.type === 'ETAB'">
          Prescrit par l'établissement {{ report.professional.name }}
        </div>
        <Dialog>
          <DialogTrigger>
            <BaseButton primary class="mt-2 w-64">
              Télécharger l'ordonnance
            </BaseButton>
          </DialogTrigger>
          <DialogContent>
            <DialogTitle>
              <SecureImage :urls="urls" print-button />
            </DialogTitle>
          </DialogContent>
        </Dialog>
      </div>
      <div class="flex flex-col items-start flex-1">
        <h3>Médicaments prescrits</h3>
        <div v-for="medication in report.medications" :key="medication.identifier">
          {{ medication.name }}
        </div>
      </div>
      <div class="flex flex-col items-end flex-1">
        <h3>Origine du signalement</h3>
        <div>Signalé à la {{ report.entity.name }}</div>
        <div v-if="report.healthcenter">
          Par {{ report.healthcenter.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
